import { mapState } from "vuex";
export default {
  // 两种方法一样
  computed: mapState({
    Currency: (state) => state.common.Currency,
  }),
  //   computed: {
  //     Currency: () => this.$store.state.common.Currency,
  //   },
  methods: {
    currencySwitches(newV, oldV) {
      this.dataList.map((item) => {
        item["title"]["right"] = item["Currency"][newV];
      });
    },
  },
  watch: {
    Currency: {
      handler(newV, oldV) {
        this.currencySwitches(newV, oldV);
      },
      immediate: true,
    },
  },
};
